<template>
  <v-card flat>
    <v-icon class="close" @click="close()">$sl-close</v-icon>
    <v-card-text>
      <h6 class="mb-4">Välj kurser</h6>
      <div class="d-flex justify-space-between align-end">
        <div>
          <template v-if="practicalCourses.length > 1">
            <v-checkbox label="Välj alla" v-model="allSelected"/>
          </template>
          <v-checkbox class="mt-0" v-for="course in practicalCourses" :key="course.id"
            :label="course.courseName" 
            v-model="courseIds"
            :value="course.id"
          /> 
        </div>
        <v-btn class="mb-3" @click="loadCourses" :disabled="loading || !practicalCourses.length">
          <v-icon>$sl-view-on</v-icon>Visualisera
        </v-btn>
      </div>
      <hr class="my-4" />
      <div v-if="theoreticalElements.length">
        <h6 class="mb-4">TEORETISKA MOMENT</h6>
        <div class="ml-4 mb-4" v-for="element in theoreticalElements" :key="element.id">
          <h6>{{element.name}}</h6>
          <div class="ml-4" v-for="subElement in element.subElements" :key="subElement.id">
            <div>{{subElement.name}}</div>
          </div>
        </div>
      </div>
      <div v-if="practicalElements.length">
        <h6 class="mb-4">PRAKTISKA MOMENT</h6>
        <div class="ml-4 mb-4" v-for="element in practicalElements" :key="element.id">
          <h6>{{element.name}}</h6>
          <div class="ml-4" v-for="subElement in element.subElements" :key="subElement.id">
            <div>{{subElement.name}}</div>
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>


<script>
import API from '@/services/api'

export default {
  name: 'ProviderBookVisualized',

  props: {
    profession: { type: Object, required: true },
    practicalCourses: { type: Array, required: true }
  },

  data: () => ({
    courseIds: [],
    theoreticalElements: [],
    practicalElements: [],
    loading: false,
  }),

  created(){
    this.courseIds = this.practicalCourses.map(p => p.id);
    this.loadCourses();
  },

  computed:{
    hasDistanceEducations(){
      return !!this.theoreticalElements;
    },
    allSelected: {
      get(){
        return this.practicalCourses.every(a => this.courseIds.includes(a.id))
      },
      set(v){
        if(!v){
          this.courseIds = []
        } else {
          this.courseIds = this.practicalCourses.map(a => a.id)
        }
      }
    }
  },

  methods: {
    loadCourses(){
      this.loading = true
      API.previewCourses(this.profession.id, this.courseIds)
        .then(({data}) => {
          const {theoreticalElements = [], practicalElements = [] } = data;
          this.theoreticalElements = theoreticalElements;
          this.practicalElements = practicalElements;
        })
        .finally(() => {
          this.loading = false
        })
    },

    close(){
      this.$emit('close')
    },
  }
}
</script>
